import api from '@/services/Api'

export default{
  changeTheme (userSettings) {
    return api().post('updateTheme', userSettings)
  },

  changeLanguage (userSettings) {
    return api().post('updateLanguage', userSettings)
  }
}
